/**
 * Tab-Route Hooks – Ersatz für useParams() und useSearchParams()
 * innerhalb des Multi-Tab-Systems.
 * 
 * Jeder Tab hat seinen eigenen RouteContext, sodass Params und SearchParams
 * unabhängig vom aktuellen Browser-URL funktionieren.
 */

import { createContext, useContext } from 'react';

export const TabRouteContext = createContext(null);

/**
 * Ersatz für useParams() aus react-router-dom.
 * Liest die Route-Parameter aus dem TabRouteContext.
 */
export function useTabParams() {
  const ctx = useContext(TabRouteContext);
  return ctx?.params || {};
}

/**
 * Ersatz für useSearchParams() aus react-router-dom.
 * Gibt [URLSearchParams, setSearchParams] zurück.
 */
export function useTabSearchParams() {
  const ctx = useContext(TabRouteContext);
  if (!ctx) {
    return [new URLSearchParams(), () => {}];
  }
  return [ctx.searchParams, ctx.setSearchParams];
}
